import { z } from "zod";

export const REPEATED_FIELD_ADDRESS_PREFIX = "repeat:";

/** Saved versions may contain identities that predate the repeat namespace. */
export const answerQuestionIdSchema = z
  .string()
  .min(1)
  .max(100)
  .refine(
    (id) => !Object.hasOwn(Object.prototype, id),
    "Question IDs cannot use reserved object property names.",
  );
/** New definitions reserve the namespace used for server-owned repeated files. */
export const questionIdSchema = answerQuestionIdSchema.refine(
  (id) => !id.startsWith(REPEATED_FIELD_ADDRESS_PREFIX),
  "Question IDs cannot use the repeat: address prefix.",
);

/**
 * Ids for the things a form is made of.
 *
 * Minted once and never reused: a question id is what every answer ever given
 * points at, and an option id is what a stored selection points at. Both
 * outlive any amount of rewording, so nothing here is derived from a label.
 */
export function newId(prefix: string): string {
  return `${prefix}_${Math.random().toString(36).slice(2, 10)}`;
}
